import { Controller } from "@hotwired/stimulus"

// Transición de página V2 sobre .tp-layout__content:
// - Entrada: connect() añade tp-fade-in (el contenido se swappea en cada
//   navegación Turbo, así el fade se reinicia por página).
// - Salida: beforeRender() pausa el render de Turbo, deja correr el fade-out y
//   lo reanuda con `event.detail.resume()` — el mecanismo que Turbo expone para
//   animar la salida (`turbo:before-render` es cancelable y trae `resume`).
//
// NO se toca `turbo:before-visit`: cancelar la visita y re-emitirla con
// Turbo.visit hacía DOS requests por navegación. En un alta eso se comía el
// flash — el primer request lo consumía y el segundo pintaba la página ya sin
// aviso. Pausar el render es lo mismo visualmente y hace un solo request.
//
// En un page refresh (morph, ej. volver al listado tras crear) no hay fade: la
// gracia del morph es que la página no parpadea.
//
// Snapshots: beforeCache() quita tp-leaving/tp-fade-in antes de que Turbo
// clone la página — sin esto, el back restaura el snapshot con opacity: 0
// (tp-leaving) y el contenido queda invisible. connect() también limpia por
// si un snapshot viejo ya viene contaminado.
const FADE_MS = 150

export default class extends Controller {
  connect() {
    // Snapshot cacheado puede traer tp-leaving grabado: quitarlo antes
    // de que la cascada lo aplique tras el fade-in (que no es forwards).
    this.element.classList.remove("tp-leaving")
    this.element.classList.add("tp-fade-in")
  }

  beforeCache() {
    this.element.classList.remove("tp-leaving", "tp-fade-in")
  }

  beforeRender(event) {
    if (event.detail.renderMethod === "morph") return

    event.preventDefault()
    this.element.classList.add("tp-leaving")
    setTimeout(() => event.detail.resume(), FADE_MS)
  }
}
